export default __webpack_public_path__ + "aca52fb056355f6601be1ba027c8969f.png";